import { ColourSwatchSelector } from '@/features/shared/components/ColourSwatchSelector';
import { projectBadgeColorOptions } from '@/shared/data/projectBadges';
import { Box, IconButton, TextField } from '@/ui/primitives';
import { DeleteFilledIcon as DeleteIcon } from '@/ui/primitives/icons';
import {
  tableRowTagEditorControlsSx,
  tableRowTagEditorRemoveButtonSx,
  tableRowTagEditorRemoveIconSx,
  tableRowTagEditorRowSx,
  tableRowTagEditorTextFieldSx,
} from './TableRowTagsDialog.styles';
import type { TagColor } from '@/shared/data/tags';

export const defaultTagColor: TagColor = 'neutral';

type TableRowTagEditorRowProps = {
  index: number;
  onColorChange: (index: number, color: TagColor) => void;
  onRemove: (index: number) => void;
  onTagChange: (index: number, value: string) => void;
  selectedColor: TagColor;
  tag: string;
};

export const TableRowTagEditorRow = ({
  index,
  onColorChange,
  onRemove,
  onTagChange,
  selectedColor,
  tag,
}: TableRowTagEditorRowProps): JSX.Element => {
  return (
    <Box sx={tableRowTagEditorRowSx}>
      <Box sx={tableRowTagEditorControlsSx}>
        <TextField
          size="small"
          inputHeight={34}
          value={tag}
          onChange={(event) => {
            onTagChange(index, event.target.value);
          }}
          fullWidth
          sx={tableRowTagEditorTextFieldSx}
        />
        <ColourSwatchSelector<TagColor>
          ariaLabel={`Choose colour for tag ${index + 1}`}
          value={selectedColor}
          options={projectBadgeColorOptions}
          onChange={(color) => {
            onColorChange(index, color);
          }}
        />
      </Box>
      <IconButton
        aria-label={`Remove tag ${index + 1}`}
        size="medium"
        sx={tableRowTagEditorRemoveButtonSx}
        onClick={() => {
          onRemove(index);
        }}
      >
        <DeleteIcon sx={tableRowTagEditorRemoveIconSx} />
      </IconButton>
    </Box>
  );
};
